<rask-header [uppercase]="true">
    Webinställningar
 </rask-header>
 <rask-container-block>
     <ng-container header>Migrering av Webinställningar</ng-container>
     <div class="row">
        <div class="col">
            <rask-input label="Typ av migrering" [(ngModel)]="typAvMigrering"></rask-input>
        </div>
     </div>
     <div class="row">
        <div class="col">
            <rask-textarea style="width: 100%" [rows]="5" label="Json-config" [(ngModel)]="configJson"></rask-textarea>
        </div>
        <div class="col">
            <rask-datepicker label="endast uppdaterade före" [onlyMonths]="false" [(ngModel)]="updatedBeforeDate"></rask-datepicker>
        </div>
     </div>
     <div class="row">
        <div class="col">
            <rask-button color="secondary" (click)="sendConfig()">Skicka</rask-button>
        </div>
     </div>
 </rask-container-block>
